var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPilotChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.828 23.503a1.715 1.715 0 0 1 0-2.434l8.76-8.76a.428.428 0 0 0 0-.618l-8.76-8.76A1.714 1.714 0 1 1 3.246.497l9.685 9.686a2.588 2.588 0 0 1 0 3.634l-9.685 9.686a1.715 1.715 0 0 1-2.418 0Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPilotChevronRight);
export default __webpack_public_path__ + "static/media/pilot-chevron-right.8b0fb1eb3d713b37b683dfd5f9e5d895.svg";
export { ForwardRef as ReactComponent };